<template>
  <div class="section01" :style="{ backgroundImage: createBackgroundString }">
    <!-- <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" /> -->
    <div class="nameband">{{ WebSetting.website_name }}</div>
    <div class="menuright">
      <div class="dropleft">
        <i
          id="clicksetting"
          class="fas fa-grip-vertical"
          data-toggle="dropdown"
          ar
        ></i>
        <div class="dropdown-menu containsideright">
          <a class="dropdown-item active" @click="$refs.chpassword.show()"
            ><i class="fas fa-lock"></i>
            เปลี่ยนรหัสผ่าน
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="onClickLogout"
            ><i class="far fa-power-off"></i> ออกจากระบบ
          </a>
        </div>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-6 p-0">
        <div class="circlecredit animate__animated animate__jackInTheBox">
          <div class="logocrcd">
            <img :src="WebSetting.logo" alt="/node_modules" />
          </div>
          <div class="incrcd" ref="homeCont">
            <div class="incrcd" v-if="walletLoading">
              ยอดเงินปัจจุบัน
              <span id="credit">{{ Auth.balance ?? "0.00" }} บาท</span>
              <i
                class="fas fa-redo"
                style="font-size: 15px; cursor: pointer"
                @click="fetchUserProfile()"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 p-0 flexcn">
        <div class="detailuser">
          <ul>
            <li>
              <strong><i class="fas fa-user"></i></strong>{{ Auth.fname }}
              {{ Auth.lname }}
            </li>
            <li>
              <strong><i class="fas fa-phone-alt"></i></strong
              >{{ changePhoneNumber(Auth.phone) }}
            </li>
            <li v-if="Auth.banknumber">
              <strong>
                <img :src="checkBankImg(Auth.bank)" alt="bank image" />
              </strong>
              {{
                changeBankNumber(Auth.banknumber)
                  ? changeBankNumber(Auth.banknumber)
                  : "-"
              }}
            </li>
            <!-- <?php } ?>
              <?php if ($tmn_id != '') { ?> -->
            <li v-if="Auth.twnId != ''">
              <strong>
                <img
                  src="@/assets/bank/truewallet.webp"
                  alt="truewallet image"
                />
              </strong>
              {{
                changePhoneNumber(Auth.twnId)
                  ? changePhoneNumber(Auth.twnId)
                  : "-"
              }}
            </li>
            <!-- <?php } ?> -->
            <!-- <li><strong style="margin-right: 2.5rem;">USER ID : </strong> <?php echo $betflix_login ?></li> -->
            <li>
              <strong>โปร</strong>
              {{ Auth.promotion }}
            </li>
            <!-- <?php if ($promo_name != 'ไม่รับโปรโมชั่น') { ?> -->
            <li>
              <u style="cursor: pointer">
                <div class="example-elements">
                  <b
                    ><p
                      :data-tooltip="Auth.promotion_detail"
                      data-tooltip-location="bottom"
                    >
                      รายละเอียด
                    </p></b
                  >
                </div>
              </u>
            </li>
            <!-- <?php } ?> -->
          </ul>
        </div>
      </div>
    </div>
    <Menu />
    <hr class="x-hr-border-glow" />
    <chpassword ref="chpassword" />
  </div>
</template>

<script>
import chpassword from "@/components/modal/ChangepwModal.vue";
import Menu from "@/components/Menu.vue";
import { mapGetters } from "vuex";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { HTTP } from "@/services/http-common";

export default {
  name: "headerinfo-component",
  components: {
    Menu,
    chpassword,
    // Loading,
  },
  data() {
    return {
      primaryColor:"#001c4d",
      isLoading: false,
      fullPage: false,
      loader: "bars",
      walletLoading: true,
      BankImg: {
        bbl: require("@/assets/bank/bangkok.svg"),
        kbank: require("@/assets/bank/kbank.svg"),
        ktb: require("@/assets/bank/krungthai.svg"),
        tmb: require("@/assets/bank/tmb.svg"),
        scb: require("@/assets/bank/scb.svg"),
        bay: require("@/assets/bank/krungsri.svg"),
        gsb: require("@/assets/bank/aomsin.svg"),
        baac: require("@/assets/bank/baac.svg"),
        tbank: require("@/assets/bank/tnc.svg"),
        ghb: require("@/assets/bank/ghb.webp"),
        scbt: require("@/assets/bank/scbt.webp"),
        ttb: require("@/assets/bank/ttb.webp"),
        city: require("@/assets/bank/city.webp"),
        cimb: require("@/assets/bank/cimb.webp"),
        uob: require("@/assets/bank/uob.webp"),
        islamic: require("@/assets/bank/islamic.webp"),
        tisco: require("@/assets/bank/tisco.webp"),
        kkp: require("@/assets/bank/kkp.webp"),
        icbc: require("@/assets/bank/icbc.webp"),
        thaicredit: require("@/assets/bank/thaicredit.webp"),
        lh: require("@/assets/bank/lh.svg"),
        truewallet: require("@/assets/bank/truewallet.webp"),
      },
      img: "",
      // bgDefault: "../../public/img/04.jpg",
    };
  },
  mounted() {
    this.fetchWebSetting();
  },
  methods: {
    onClickLogout() {
      this.$store.dispatch("logoutAuth");
      this.$router.push("/login");
    },
    // wallet() {
    //   if (this.Auth.balance) {
    //     let wallet =
    //       parseInt(this.Auth.balance) + parseInt(this.Auth.balanceBetflix);
    //     return wallet.toFixed(2);
    //   }
    // },
    fetchWebSetting() {
      HTTP.get(`system/info`)
        .then((resp) => {
          this.$store.dispatch("savePageSetting", resp.data.data);
          if(resp.data.data != null && resp.data.data.color1 != null)
          {
            this.primaryColor = resp.data.data.color1;
          }          
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    fetchUserProfile() {
      this.showNewLoader();
      this.walletLoading = false;
      HTTP.get(`member/profile`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
            );
          } else {
            if (resp.data.status != undefined && resp.data.status) {
              this.$store.dispatch("saveProfile", resp.data.data);
            }
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
          );
        });
    },
    showNewLoader() {
      let homeCont = this.$refs.homeCont;
      let loader = this.$loading.show({
        container: homeCont,
        loader: "Dots",
        color: "red",
        opacity: 0,
      });
      setTimeout(() => {
        this.walletLoading = true;
        loader.hide();
      }, 2000);
    },
    changeBankNumber(number) {
      const set1 = number.substring(0, 3);
      const set2 = number.substring(3, 9);
      const set3 = number.substring(9, 10);
      const set4 = number.substring(10, 12);
      const sum = `${set1}-${set2}-${set3}${set4}`;
      return sum;
    },
    changePhoneNumber(number) {
      if (number) {
        const set1 = number.substring(0, 3);
        const set2 = number.substring(3, 7);
        const set3 = number.substring(7, 10);
        const sum = `${set1}-${set2}-${set3}`;
        console.log(sum);
        return sum;
      }
    },
    checkBankImg(bank) {
      if (bank === "กรุงเทพ") return this.BankImg.bbl;
      if (bank === "กสิกรไทย") return this.BankImg.kbank;
      if (bank === "กรุงไทย") return this.BankImg.ktb;
      if (bank === "ทหารไทยธนชาต") return this.BankImg.tmb;
      if (bank === "ไทยพาณิชย์") return this.BankImg.scb;
      if (bank === "ธกส") return this.BankImg.baac;
      if (bank === "กรุงศรีฯ") return this.BankImg.bay;
      if (bank === "ออมสิน") return this.BankImg.gsb;
      if (bank === "ธอส") return this.BankImg.ghb;
      if (bank === "แสตนดาร์ดชาร์เตอร์") return this.BankImg.scbt;
      if (bank === "ซิตี้แบงค์") return this.BankImg.city;
      if (bank === "ซีไอเอ็มบีไทย") return this.BankImg.cimb;
      if (bank === "ยูโอบี") return this.BankImg.uob;
      if (bank === "อิสลาม") return this.BankImg.islamic;
      if (bank === "ทิสโก้") return this.BankImg.tisco;
      if (bank === "เกียรตินาคิณภัทร") return this.BankImg.kkp;
      if (bank === "ไอซีบีซี") return this.BankImg.icbc;
      if (bank === "ไทยเครดิต") return this.BankImg.thaicredit;
      if (bank === "LHBANK") return this.BankImg.lh;
      if (bank === "truewallet") return this.BankImg.truewallet;
    },
  },
  computed: {
    ...mapGetters(["Auth"]),
    ...mapGetters(["WebSetting"]),
    // bgStyles() {
    //   return {
    //     background: `linear-gradient(152deg, #611b1eb0, #130205), url(
    //     ${this.img != null ? this.img : this.bgDefault}) top center`,
    //   };
    // },
    
    createBackgroundString() {
      return `linear-gradient(152deg, ${this.primaryColor}, #130205)`;
    }
  },
};
</script>

<style></style>
